<template>
	<div>
		<nav id="navbarBottom" class="navbar navbar-expand">
			<span class="before-transparent"></span>
			<div class="nav-button nav-button-previous" @click="navigationPrevious()">
				<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
					viewBox="0 0 44 42" style="enable-background:new 0 0 44 42;" xml:space="preserve">
				<g id="Gruppe_4038" transform="translate(-233.001 -68)">
					<g id="Gruppe_478" transform="translate(273.333 108.333) rotate(180)">
						<g id="Ellipse_3" transform="translate(0.332 0.333)">
							<circle class="st0" cx="18" cy="19" r="20"/>
							<circle class="st1" cx="18" cy="19" r="19"/>
						</g>
						<path id="Pfad_445" class="st2" d="M14.3,8.9l10.4,10.4L14.3,29.7"/>
					</g>
				</g>
				</svg>
			</div>
			<div class="container navbar-inner">
				<ul class="nav">
					<template v-for="(navlink, index) in navigationData" :key="index">
						<li v-if="navlink.config.pictures != '' && navlink.type != 'freeTexts' && navlink.config.title != ''" class="nav-item">
							<a class="nav-link" :href="['#container-' + index + '-' + navlink.type]" :class="{'active': index == '0'}" >{{ navlink.config.title }}</a>
						</li>
						<template v-else-if="navlink.type =='freeTexts'" >
							<template v-for="(field, index) in navigationData[index].config.fields" :key="index">
								<li v-if="field.type != ''" class="nav-item">
									<a class="nav-link" :href="['#container-' + index + '-' + field.type]" >{{ field.title }}</a>
								</li>
							</template>
						</template>
					</template>
				</ul>
			</div>
			<div class="nav-button nav-button-next" @click="navigationNext()">
				<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
					viewBox="0 0 44 42" style="enable-background:new 0 0 44 42;" xml:space="preserve">
				<g id="Gruppe_4038" transform="translate(-233.001 -68)">
					<g id="Gruppe_478" transform="translate(273.333 108.333) rotate(180)">
						<g id="Ellipse_3" transform="translate(0.332 0.333)">
							<circle class="st0" cx="18" cy="19" r="20"/>
							<circle class="st1" cx="18" cy="19" r="19"/>
						</g>
						<path id="Pfad_445" class="st2" d="M14.3,8.9l10.4,10.4L14.3,29.7"/>
					</g>
				</g>
				</svg>
			</div>
			<span class="after-transparent"></span>
		</nav>
	</div>
</template>

<script>

import { ScrollSpy } from 'bootstrap';

export default {
	props: {
		navigationData: {
			type: Object
		},
		mainSettings: {
			type: Object
		}
	},

	methods: {
		
		computeMargin() {
			const beforeTransparent = document.querySelector('.before-transparent');
			const afterTransparent = document.querySelector('.after-transparent');
			let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

			if (viewportWidth > 1199) {
				const item = document.querySelector('.navbar-inner');
				const style= getComputedStyle(item);
				const itemMargin = style.marginLeft;

				beforeTransparent.style.left = `calc(${itemMargin} + 32px)`;
				afterTransparent.style.right = `calc(${itemMargin} + 32px)`;
			}
			else {
				beforeTransparent.style.left = '32px';
				afterTransparent.style.right = '32px';
			}

			window.addEventListener('resize', function() {
				if (viewportWidth > 1199) {
					const item = document.querySelector('.navbar-inner');
					const style= getComputedStyle(item);
					const itemMargin = style.marginLeft;

					beforeTransparent.style.left = `calc(${itemMargin} + 32px)`;
					afterTransparent.style.right = `calc(${itemMargin} + 32px)`;
				}
				else {
					beforeTransparent.style.left = '32px';
					afterTransparent.style.right = '32px';
				}
			});
		},

		navigationClick() {
			let navbar = document.querySelector(".navbar-inner");
			let navbarLinks = document.querySelectorAll("nav a");
			let navbarOffsetLeft = navbar.offsetLeft + 64;

			navbarLinks.forEach(function(clickedLink) {
				clickedLink.addEventListener("click", function() {
					setTimeout(()=> {
						if(document.location.hash === clickedLink.getAttribute('href')) {
							window.scrollTo({
								top: document.querySelector(clickedLink.getAttribute('href')).offsetTop,
								behavior: "smooth"
							});
						}
					}, 1)

					navbar.scrollTo({
						top: 0,
						left: this.offsetLeft - navbarOffsetLeft,
						behavior: "smooth"
					});
				});
			});
		},

		navigationScroll() {
			let navbarLinks = document.querySelectorAll("nav a");

			var scrollSpy = new ScrollSpy(document.body, {
				target: '#navbarBottom',
				offset: 200
			});

			
			var dataSpyList = [].slice.call(document.querySelectorAll('[data-bs-spy="scroll"]'));
			
			dataSpyList.forEach(function (dataSpyEl) {				
				scrollSpy.getInstance(dataSpyEl)
				.refresh()
			});
			

			window.addEventListener('activate.bs.scrollspy', function () {
				const previousButton = document.querySelector('.nav-button-previous');
				const nextButton = document.querySelector('.nav-button-next');

				for (let index = 0; index < navbarLinks.length; index++) {
					if (navbarLinks[0].classList.contains('active')) {
						previousButton.style.visibility = 'hidden';
					}
					else {
						previousButton.style.visibility = 'visible';
					}

					if (navbarLinks[navbarLinks.length - 1].classList.contains('active')) {
						nextButton.classList.add('nav-button-end');
					}
					else {
						nextButton.classList.remove('nav-button-end');
					}
				}
			});
		},

		navigationPrevious() {
			let navbarLinks = document.querySelectorAll("nav a");

			for (let index = 1; index < navbarLinks.length; index++) {
				const currentLink = navbarLinks[index];

				if (currentLink.classList.contains('active')) {
					navbarLinks[index - 1].click();
					break
				}
			}
		},

		navigationNext() {
			let navbarLinks = document.querySelectorAll("nav a");

			for (let index = 0; index < navbarLinks.length; index++) {
				const currentLink = navbarLinks[index];

				if (currentLink.classList.contains('active') && index < navbarLinks.length - 1) {
					navbarLinks[index + 1].click();
					break
				}
				else if (currentLink.classList.contains('active') && index == navbarLinks.length - 1) {
					window.scrollTo({
						top: 0,
						behavior: 'smooth'
					});
				}
			}
		},

		listenToScroll() {
			window.addEventListener('scroll', function() {
				let navbar = document.querySelector(".navbar-inner");
				let navbarLinks = document.querySelectorAll("nav a");
				let navbarOffsetLeft = navbar.offsetLeft + 64;

				for (let index = 0; index < navbarLinks.length; index++) {
					const currentLink = navbarLinks[index];
					
					if (currentLink.classList.contains('active')) {
						navbar.scrollTo({
							top: 0,
							left: currentLink.offsetLeft - navbarOffsetLeft,
							behavior: "smooth"
						});
						break
					}
				}
			});
		}
	},
	
	mounted() {
		this.computeMargin();
		this.navigationClick();
		this.navigationScroll();
		this.listenToScroll();
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/navigationComponent.scss";
</style>
